// redux/actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const access_token = process.env.REACT_APP_GET_PLAYER_TOKEN;
const ftv_access_token = process.env.REACT_APP_GET_FTV_PLAYER_TOKEN;
const spinmile_access_token = process.env.REACT_APP_GET_SPINMILE_PLAYER_TOKEN;
const msw_access_token = process.env.REACT_APP_GET_MSW_PLAYER_TOKEN;
const REACT_APP_STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const apiBaseUrl = process.env.REACT_APP_STRAPI_URL;


const fetchConfig = async (data: { brand: string; lang: string }, pageType: string) => {
    let response = null;

    if (pageType == "call") {
        response = await fetch(
            `${REACT_APP_STRAPI_URL}/web-rtc-configs?locale=${data.lang}&populate=deep,3&filters[Template][Brand][$eq]=${data.brand}`
        );
    } else {
        response = await fetch(
            `${REACT_APP_STRAPI_URL}/${pageType}-pages?locale=${data.lang}&populate=deep,3&filters[Template][Brand][$eq]=${data.brand}`
        );
    }
    if (!response.ok) {
        throw new Error('Failed to fetch config');
    }
    return response.json();
};

export const pullConfig = createAsyncThunk(
    'config/pullConfig',
    async ({ data, pageType }: { data: { brand: string; lang: string }; pageType: string }, { rejectWithValue }) => {
        try {
            const configData = await fetchConfig(data, pageType);
            const data_j = configData.data;

            if (!data_j || data_j.length === 0) {
                return null;
            }
            return configData;
        } catch (error) {
            // Use type guard to check if `error` has a `message` property
            if (error instanceof Error) {
                return null;
            }
            return null;
        }
    }
);

// Function to fetch players data based on the "s" value and brand
const fetchPlayers = async (s: string, brand: string) => {
    if (brand.toLowerCase() === 'ftv') {
        const response = await fetch(`${REACT_APP_STRAPI_URL}/ftv/players/${s}`, {
            headers: {
                'Authorization': `bearer ${ftv_access_token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to fetch player data');
        }
    } else if (brand.toLowerCase() === 'spinmile') {
        const response = await fetch(`${REACT_APP_STRAPI_URL}/spin-mile/players/${s}`, {
            headers: {
                'Authorization': `bearer ${spinmile_access_token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to fetch player data');
        }
        return response.json();
    } else if (brand.toLowerCase() === 'msw') {
        const response = await fetch(`${REACT_APP_STRAPI_URL}/msw/players/${s}`, {
            headers: {
                'Authorization': `bearer ${msw_access_token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to fetch player data');
        }
        return response.json();
    } else {
        const response = await fetch(`${REACT_APP_STRAPI_URL}/players/${s}`, {
            headers: {
                'Authorization': `bearer ${access_token}`
            }
        });
        if (!response.ok) {
            throw new Error('Failed to fetch player data');
        }
        return response.json();
    }
};


// Thunk for pulling players data
export const pullPlayers = createAsyncThunk(
    'players/pullPlayers',
        async ({ s, brand }: { s: string; brand: string }) => {
        return await fetchPlayers(s, brand);
    }
);

// Thunk for pulling individual player data based on brand
export const pullPlayerData = createAsyncThunk(
    'players/pullPlayerData',
    async ({ playerId, brand }: { playerId: string; brand: string }, { rejectWithValue }) => {
        try {
            alert(playerId);
            if (brand.toLowerCase() === 'ftv') {
                const { data } = await axios.get(`${apiBaseUrl}/ftv/players/${playerId}`, {
                    headers: {
                        'Authorization': `bearer ${ftv_access_token}`
                    }
                });
                return data;
            } else if (brand.toLowerCase() === 'spinmile') {
                
                const { data } = await axios.get(`${apiBaseUrl}/spin-mile/players/${playerId}`, {
                    headers: {
                        'Authorization': `bearer ${spinmile_access_token}`
                    }
                });
                return data;
            }  else if (brand.toLowerCase() === 'msw') {
                
                const { data } = await axios.get(`${apiBaseUrl}/msw/players/${playerId}`, {
                    headers: {
                        'Authorization': `bearer ${msw_access_token}`
                    }
                });
                return data;
            } else {
                const { data } = await axios.get(`${apiBaseUrl}/players/${playerId}`, {
                    headers: {
                        'Authorization': `bearer ${access_token}`
                    }
                });
                return data;
            }
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch player data');
        }
    }

);
